<!-- 活动清单 多选组件 -->
<template>
  <div class="chat-card-box">
    <div class="chat-card" v-for="(item, index) in checkboxList" :key="index">
      <div class="chat-title">
        <span class="title-icon" :style="`color: ${item.color}`">“</span>
        <div class="title">
          {{ item.title }}
        </div>
      </div>
      <div class="checkbox-list">
        <div
          class="checkbox-item"
          v-for="(itemTag, indexTag) in item.selectValArr"
          :key="'tag' + indexTag"
          @click="selectItem(itemTag)"
        >
          <div class="checkbox-item-box" :style="`backgroundColor: ${item.color}`">
            {{ itemTag.label }}
            <icon
              v-if="selectActivity.includes(itemTag.label)"
              class="checked-icon"
              name="success"
              color="#43CF7C"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="add-area">
      <input
        class="add-input"
        :disabled="!isCanEdit"
        type="text"
        v-model="otherActivity"
        placeholder="输入自己喜欢的活动"
      />
    </div>
    <!-- <div class="add-btn">
      +
    </div> -->
    <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import { Icon } from "vant";
import { dictDataType } from "@/api/app";
export default {
  name: "ChatCheckbox",
  components: { Icon },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {
          isShowTime: true,
        };
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      checkboxList: [
        {
          title: "运动",
          color: "#F2F8FC",
          type: "merry_exercise",
          selectValArr: [],
        },
        {
          title: "探索",
          color: "#FAF1DF",
          type: "merry_dietary",
          selectValArr: [],
        },
        {
          title: "社交",
          color: "#E9E0FF",
          type: "merry_social",
          selectValArr: [],
        },
        {
          title: "娱乐",
          color: "#F2F8FC",
          type: "merry_recreation",
          selectValArr: [],
        },
        {
          title: "家庭",
          color: "#FAF1DF",
          type: "merry_family",
          selectValArr: [],
        },
        {
          title: "公益",
          color: "#E9E0FF",
          type: "merry_relaxation",
          selectValArr: [],
        },
        {
          title: "行为练习",
          color: "#F2F8FC",
          type: "merry_behavior_practice",
          selectValArr: [],
        },
      ],
      selectActivity: [],
      otherActivity: "",
    };
  },
  created() {},
  mounted() {
    if (this.nextData?.step_data?.survey?.qstList[0].answer) {
      let useData = this.nextData.step_data.survey.qstList[0].answer;
      this.selectActivity = useData.selectActivity;
      this.otherActivity = useData.otherActivity;
    }
    this.getDictDataType();
  },
  methods: {
    // 查询大类的子集
    getDictDataType() {
      this.checkboxList.forEach((item, index) => {
        dictDataType(item.type).then((res) => {
          this.checkboxList[index].selectValArr = res;
        });
      });
    },
    selectItem(tag) {
      if (!this.isCanEdit) {
        return;
      }
      const findIndex = this.selectActivity.findIndex((item) => item === tag.label);
      if (findIndex === -1) {
        this.selectActivity.push(tag.label);
      } else {
        this.selectActivity.splice(findIndex, 1);
      }
    },

    confirmFn() {
      console.log(this.cardData, "this.cardData");

      const useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  selectActivity: this.selectActivity,
                  otherActivity: this.otherActivity,
                },
              },
            ],
          },
        },
      };
      console.log(useData, "useData");
      this.$emit("confirmFn", useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card-box {
  box-sizing: border-box;
  padding-top: 10px;
}
.chat-card {
  width: 342px;
  box-sizing: border-box;
  margin-bottom: 14px;
  .chat-title {
    position: relative;
    width: 100%;
    height: 22px;
    margin-bottom: 6px;
    .title-icon {
      text-align: center;
      vertical-align: middle;
      display: block;
      font-size: 60px;
      position: absolute;
      z-index: 9;
      top: 11px;
      left: -4px;
      color: #cfecff;
      width: 22px;
      line-height: 20px;
    }
    .title {
      font-size: 16px;
      font-weight: 600;
      color: rgba(18, 18, 18, 1);
      position: absolute;
      z-index: 99;
      top: 0px;
      left: 0px;
      line-height: 22px;
    }
  }
  .checkbox-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 创建四列，每列等宽 */
    grid-gap: 8px; /* 行和列之间的间隔 */

    .checkbox-item {
      .checkbox-item-box {
        border-radius: 3px;
        background: #ffffff;
        line-height: 14px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(18, 18, 18, 0.4);
        padding: 4px 12px 4px 4px;
        box-sizing: border-box;
        position: relative;

        .checked-icon {
          width: 8px;
          height: 8px;
          position: absolute;
          right: 4px;
          bottom: 4px;
        }
      }
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}

.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12.66px;
  background: #3895ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: rgba(255, 255, 255, 1);
  border: none;
  margin: 10px auto 0;
}
.add-area {
  width: 342px;
  height: 69px;
  border-radius: 17px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  box-sizing: border-box;
  .add-input {
    width: 100%;
    color: $text-color;
    border: none;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;

    &::placeholder {
      font-size: 12px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}

.add-btn {
  margin-top: 14px;
  width: 342px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  box-sizing: border-box;
  border-radius: 17px;
  background: #ffffff;
  color: #999;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
